"use client";
import { IAccountAssets, IBlocks, IUserData } from "@/types";
import BlockToggle from "../toggle";
import { Slider } from "@/components/ui/slider";
import { Input } from "@/components/ui/input";
import React from "react";
import { replaceProtocolWithHTTPS, startsWithHTTPS } from "@/lib/utils";
import { toast } from "sonner";
import { Separator } from "@/components/ui/separator";
import CardSetting from "@/components/admin/settings/CardSetting";
import Assets from "@/components/admin/assets";
interface Props {
    block: IBlocks;
    blockUpdate: React.Dispatch<React.SetStateAction<IBlocks>>;
    update: (value: IBlocks) => void;
    assets: IAccountAssets[];
    account_id?: string;
    impersonate?: any;
    account: IUserData;
}
export default function ImageOptions({
    block,
    blockUpdate,
    update,
    assets,
    account_id,
    impersonate,
    account,
}: Props) {
    const [oldBlock, setOldBlock] = React.useState(block);
    return (
        <div className="flex w-full flex-col gap-3">
            <CardSetting
                noBorder
                title="Click through URL"
                description="When you click the image, do you want it to go somewhere? Can be left blank"
            >
                <Input
                    variant="card"
                    className="w-full"
                    required
                    value={block.options.link}
                    onChange={(e) =>
                        blockUpdate({
                            ...block,
                            options: {
                                ...block.options,
                                link: e.target.value,
                            },
                        })
                    }
                    onBlur={(e) => {
                        if (
                            !startsWithHTTPS(e.target.value) &&
                            e.target.value.length != 0
                        ) {
                            e.target.value = replaceProtocolWithHTTPS(
                                e.target.value
                            );
                            blockUpdate({
                                ...block,
                                options: {
                                    ...block.options,
                                    link: e.target.value,
                                },
                            });
                        }
                        if (oldBlock.options.link != e.target.value) {
                            update({
                                ...block,
                                options: {
                                    ...block.options,
                                    link: e.target.value,
                                },
                            });
                            setOldBlock({
                                ...oldBlock,
                                options: {
                                    ...block.options,
                                    link: e.target.value,
                                },
                            });
                        }
                    }}
                />
            </CardSetting>
            <Separator />
            <CardSetting title="Image size">
                <Slider
                    max={100}
                    step={20}
                    min={20}
                    value={[block.options.size]}
                    onValueChange={(value) => {
                        update({
                            ...block,
                            options: {
                                ...block.options,
                                size: value,
                            },
                        });
                    }}
                />
            </CardSetting>
            <Separator />
            <Assets
                _assets={assets}
                //@ts-expect-error
                impersonate={
                    impersonate
                        ? {
                              id: impersonate.id,
                          }
                        : null
                }
                block={block}
                update={(asset) => {
                    update({
                        ...block,
                        url: asset.url,
                    });
                }}
                account_id={account_id}
                account={account}
            />
        </div>
    );
}
export function BlockOptions({ block, blockUpdate, update }: Props) {
    return (
        <BlockToggle block={block} blockUpdate={blockUpdate} update={update} />
    );
}
